// 公共
import system from '../locale/modules/system'
// 首页
import home from '../locale/modules/home'
// 权限
import permission from '../locale/modules/permission'
// 产品
import productLocale from '../locale/modules/productLocale'
// 别名
import batchLocale from '../locale/modules/batchLocale'

import customer from '../locale/modules/customer'
import notice from '../locale/modules/noticeLocale'
// 导航
import main from '../locale/modules/main'
// 地理信息
import locationLocal from '../locale/modules/locationLocal'
// 临期资质
import expiringQualificationLocale from '../locale/modules/expiringQualificationLocale'
// 流向商业
import distributor from '../locale/modules/distributorList'
// 收货方主数据
import receiverLocal from './modules/receiverLocal'
// 产品权限组
import productGroup from '../locale/modules/productGroupLocal'
// 流向管理
import salseFlowLocale from '../locale/modules/salseFlowLocale'
// 进销存管理
import inventory from '../locale/modules/inventory'
// 货主
import shipperLocale from '../locale/modules/shipperLocale'
// 库房
import warehouseLocale from '../locale/modules/warehouseLocale'
// 货主产品库房关联管理
import shipperWarehouseProductLocale from '../locale/modules/shipperWarehouseProductLocale'

// 协议维护信息
import customerAgreementLocale from '../locale/modules/customerAgreementLocale'
// 产品价格协议维护信息
import priceAgreementLocale from '../locale/modules/priceAgreementLocale'
// 产品价格协议维护信息
import reportLocal from '../locale/modules/reportLocale'

// GXP商业资信维护
import creditLocale from '../locale/modules/creditLocale'

// 销售计划
import salesPlanLocale from '../locale/modules/salesPlanLocale'

// 订单管理
import orderLocale from '../locale/modules/orderLocale'

// 招标管理
import biddingLocale from '../locale/modules/biddingLocale'

// 招标补偿
import biddingCompensation from '../locale/modules/biddingCompensation'
// 招标管理
import certificate from '../locale/modules/certificate'
// 巡店
import visit from '../locale/modules/visitLocale'

import agreementNotice from '../locale/modules/agreementNotice'
export default {
    'zh-CN': {
        main: main.zhCN.main,
        system: system.zhCN.system,
        home: home.zhCN.home,
        homeSetting: home.zhCN.homeSetting,
        userlist: permission.zhCN.userlist,
        customer: customer.zhCN.customer,
        notice: notice.zhCN.notice,
        // 产品
        public: productLocale.zhCN.public,
        productBatch: productLocale.zhCN.productBatch,
        bu: productLocale.zhCN.bu,
        productLine: productLocale.zhCN.productLine,
        brand: productLocale.zhCN.brand,
        ignoreMaterialHistroy: productLocale.zhCN.ignoreMaterialHistroy,
        product: productLocale.zhCN.product,
        // 别名
        ignoreProductBatchHistroy: batchLocale.zhCN.ignoreProductBatchHistroy,
        batchImport: batchLocale.zhCN.batchImport,
        productAnother: batchLocale.zhCN.productAnother,
        productBatchAnother: batchLocale.zhCN.productBatchAnother,
        expiringPublic: expiringQualificationLocale.zhCN.public,
        // 流向商业--临期资质
        expiringQualification: expiringQualificationLocale.zhCN.expiringQualification,
        // 流向商业
        distributor: distributor.zhCN.distriButorSystem,
        // 流向商业---全部
        distributorAll: distributor.zhCN.distributorAll,
        // 地理信息
        locationConfirm: locationLocal.zhCN.locationConfirm,
        // 地理信息---城市
        city: locationLocal.zhCN.city,
        // 地理信息---区县
        county: locationLocal.zhCN.county,
        // 地理信息---大区
        area: locationLocal.zhCN.area,
        // 军区管理-
        military: locationLocal.zhCN.military,
        // 系统管理--收货方类型
        receiverType: receiverLocal.zhCN.receiverType,
        // 院边店
        drugstoreNearHospital: receiverLocal.zhCN.drugstoreNearHospital,

        // 系统管理--产品权限组
        productGroup: productGroup.zhCN.productGroup,
        // 收货方主数据
        receiver: receiverLocal.zhCN.receiver,
        receiverAliasChangeRequestForm: receiverLocal.zhCN.receiverAliasChangeRequestForm,
        // 流向管理-数据导入
        importData: salseFlowLocale.zhCN.importData,
        // 流向管理-数据删除
        deleteData: salseFlowLocale.zhCN.deleteData,
        // 流向管理-数据查询
        queryData: salseFlowLocale.zhCN.queryData,
        // 流向管理-流向核查
        deficiencyInspect: salseFlowLocale.zhCN.deficiencyInspect,
        // 进销存管理导航
        inventoryMain: inventory.zhCN.inventoryMain,
        // 进销存管理-流向商业库存天数
        distributorInventoryDay: inventory.zhCN.distributorInventoryDay,
        // 进销存管理
        inventoryList: inventory.zhCN.inventoryList,
        // 库存差异核查
        inventoryInspect: inventory.zhCN.inventoryInspect,
        // 进销存报表
        inventoryReport: inventory.zhCN.inventoryReport,
        // 货主管理
        shipperPublic: shipperLocale.zhCN.public,
        shipper: shipperLocale.zhCN.shipper,
        // 安全库存范围设置
        safetyStockRange: inventory.zhCN.safetyStockRange,
        // 库房管理
        warehousePublic: warehouseLocale.zhCN.public,
        warehouse: warehouseLocale.zhCN.warehouse,
        // 货主产品库房关联管理
        shipperWarehouseProductPublic: shipperWarehouseProductLocale.zhCN.public,
        shipperWarehouseProduct: shipperWarehouseProductLocale.zhCN.shipperWarehouseProduct,
        // 协议维护信息
        customerAgreementPublic: customerAgreementLocale.zhCN.public,
        customerAgreement: customerAgreementLocale.zhCN.customerAgreement,
        // 产品价格协议维护信息
        priceAgreementPublic: priceAgreementLocale.zhCN.public,
        priceAgreement: priceAgreementLocale.zhCN.priceAgreement,
        // 收货方统计
        receiverReport: reportLocal.zhCN.receiverReport,
        // 发货方统计
        distributorReport: reportLocal.zhCN.distributorReport,
        // GXP商业资信维护
        creditPublic: creditLocale.zhCN.public,
        credit: creditLocale.zhCN.credit,

        // 销售计划
        salesPlan: salesPlanLocale.zhCN.salesPlan,
        achievingRateReport: salesPlanLocale.zhCN.achievingRateReport,

        // 订单处理
        orderProcessing: orderLocale.zhCN.orderProcessing,
        // 订单流程
        orderProcess: orderLocale.zhCN.orderProcess,
        // GXP账单维护
        maintenance: orderLocale.zhCN.maintenance,
        // 订单明细查询
        orderdetail: orderLocale.zhCN.orderdetail,
        // 招标列表
        bidding: biddingLocale.zhCN.bidding,
        // 招标明细
        biddingDetail: biddingLocale.zhCN.biddingDetail,
        // 日库存差异率设置
        discrepancyRateSetting: inventory.zhCN.discrepancyRateSetting,
        // 经销商库存预估设置
        inventoryEstimateSetting: inventory.zhCN.inventoryEstimateSetting,
        // 招标价格验证
        biddingPriceConflict: biddingLocale.zhCN.biddingPriceConflict,
        // 招标流程步骤
        biddingSteps: biddingLocale.zhCN.biddingSteps,
        // 招标类型管理
        biddingType: biddingLocale.zhCN.biddingType,
        // 招标申请
        biddingRequest: biddingLocale.zhCN.biddingRequest,
        // 自动服务运行状态查询
        taskStatus: system.zhCN.taskStatus,
        // 招标补偿 -- 补偿汇总记录查询
        compensationSummaryList: biddingCompensation.zhCN.compensationSummaryList,
        // 招标补偿 -- 药店补偿名单维护
        drugStoreSetting: biddingCompensation.zhCN.drugStoreSetting,
        // 招标管理
        certificate: certificate.zhCN.certificate,
        // 补偿计算
        compensationCalculation: biddingCompensation.zhCN.compensationCalculation,
        // DTP药店基础数据
        drugstore: visit.zhCN.drugstore,
        // 巡店计划
        visitPlan: visit.zhCN.visitPlan,
        // 巡店结果
        visitResult: visit.zhCN.visitResult,
        // BU与药店基础数据
        drugstoreBUManagement: visit.zhCN.drugstoreBUManagement,
        agreementNotice: agreementNotice.zhCN.agreementNotice,
        // 回款商业
        paymentCollection: orderLocale.zhCN.paymentCollection,
        // 合作方管理
        partnerManagement: orderLocale.zhCN.partnerManagement,
        // 招标月度实际采购价
        biddingMonthRealPrice: biddingLocale.zhCN.biddingMonthRealPrice,
        // 日数据预警
        dailySalesflowDefference: salseFlowLocale.zhCN.dailySalesflowDefference,
        // DTP数据管理
        dtpDataManagement: salseFlowLocale.zhCN.dtpDataManagement,
        // 招标补偿 -- D&W补偿名单维护
        dwCompensationSetting: biddingCompensation.zhCN.dwCompensationSetting,
        // 招标补偿 -- D&W补偿系数维护
        dwCompensationCoefficientSetting: biddingCompensation.zhCN.dwCompensationCoefficientSetting,
        // 发货模式
        shippingModeManagement: visit.zhCN.shippingModeManagement,
        //委托进口折让单价
        commissiondImport: biddingCompensation.zhCN.commissiondImport,
        //库存天数维护
        inventoryDaysMaintenance: inventory.zhCN.inventoryDaysMaintenance,
        //T1进销存进展
        inventoryOverview: inventory.zhCN.inventoryOverview,
        //分货报表
        salesPlanDistributionReport: salesPlanLocale.zhCN.salesPlanDistributionReport,
    },
    'en-US': {
        main: main.enUS.main,
        system: system.enUS.system,
        home: home.enUS.home,
        customer: customer.enUS.customer,
        notice: notice.enUS.notice,
        homeSetting: home.zhCN.homeSetting,
        userlist: permission.enUS.userlist,
        // 产品
        public: productLocale.enUS.public,
        productBatch: productLocale.enUS.productBatch,
        bu: productLocale.enUS.bu,
        productLine: productLocale.enUS.productLine,
        brand: productLocale.enUS.brand,
        ignoreMaterialHistroy: productLocale.enUS.ignoreMaterialHistroy,
        product: productLocale.enUS.product,
        // 别名
        ignoreProductBatchHistroy: batchLocale.enUS.ignoreProductBatchHistroy,
        batchImport: batchLocale.enUS.batchImport,
        productAnother: batchLocale.enUS.productAnother,
        productBatchAnother: batchLocale.enUS.productBatchAnother,
        expiringPublic: expiringQualificationLocale.enUS.public,
        // 流向商业--临期资质
        expiringQualification: expiringQualificationLocale.enUS.expiringQualification,
        // 流向商业--公共
        distributor: distributor.enUS.distriButorSystem,
        // 流向商业---全部
        distributorAll: distributor.enUS.distributorAll,
        // 地理信息
        locationConfirm: locationLocal.enUS.locationConfirm,
        // 地理信息---城市
        city: locationLocal.enUS.city,
        // 地理信息---区县
        county: locationLocal.enUS.county,
        // 地理信息---大区
        area: locationLocal.enUS.area,
        // 军区管理-
        military: locationLocal.enUS.military,
        // 系统管理--收货方类型
        receiverType: receiverLocal.enUS.receiverType,
        // 系统管理--产品权限组
        productGroup: productGroup.enUS.productGroup,
        // 收货方主数据
        receiver: receiverLocal.enUS.receiver,
        // 院边店
        drugstoreNearHospital: receiverLocal.enUS.drugstoreNearHospital,

        receiverAliasChangeRequestForm: receiverLocal.enUS.receiverAliasChangeRequestForm,
        // 流向管理-数据导入
        importData: salseFlowLocale.enUS.importData,
        // 流向管理-数据删除
        deleteData: salseFlowLocale.enUS.deleteData,
        // 流向管理-流向核查
        deficiencyInspect: salseFlowLocale.enUS.deficiencyInspect,
        // 流向管理-数据查询
        queryData: salseFlowLocale.enUS.queryData,
        // 进销存管理导航
        inventoryMain: inventory.enUS.inventoryMain,
        // 进销存管理-流向商业库存天数
        distributorInventoryDay: inventory.enUS.distributorInventoryDay,
        // 进销存管理
        inventoryList: inventory.enUS.inventoryList,
        // 库存差异核查
        inventoryInspect: inventory.enUS.inventoryInspect,
        // 进销存报表
        inventoryReport: inventory.enUS.inventoryReport,
        // 货主管理
        shipperPublic: shipperLocale.enUS.public,
        shipper: shipperLocale.enUS.shipper,
        // 安全库存范围设置
        safetyStockRange: inventory.enUS.safetyStockRange,
        // 库房管理
        warehousePublic: warehouseLocale.enUS.public,
        warehouse: warehouseLocale.enUS.warehouse,
        // 货主产品库房关联管理
        shipperWarehouseProductPublic: shipperWarehouseProductLocale.enUS.public,
        shipperWarehouseProduct: shipperWarehouseProductLocale.enUS.shipperWarehouseProduct,
        // 协议维护信息
        customerAgreementPublic: customerAgreementLocale.enUS.public,
        customerAgreement: customerAgreementLocale.enUS.customerAgreement,
        // 产品价格协议维护信息
        priceAgreementPublic: priceAgreementLocale.enUS.public,
        priceAgreement: priceAgreementLocale.enUS.priceAgreement,
        // 收货方统计
        receiverReport: reportLocal.enUS.receiverReport,
        // 发货方统计
        distributorReport: reportLocal.enUS.distributorReport,
        // GXP商业资信维护
        creditPublic: creditLocale.enUS.public,
        credit: creditLocale.enUS.credit,

        // 销售计划
        salesPlan: salesPlanLocale.enUS.salesPlan,
        achievingRateReport: salesPlanLocale.enUS.achievingRateReport,
        // 订单处理
        orderProcessing: orderLocale.enUS.orderProcessing,
        // 订单流程
        orderProcess: orderLocale.enUS.orderProcess,
        // GXP账单维护
        maintenance: orderLocale.enUS.maintenance,
        // 订单明细查询
        orderdetail: orderLocale.enUS.orderdetail,
        // 招标列表
        bidding: biddingLocale.enUS.bidding,
        // 招标明细
        biddingDetail: biddingLocale.enUS.biddingDetail,
        // 日库存差异率设置
        discrepancyRateSetting: inventory.enUS.discrepancyRateSetting,
        // 经销商库存预估设置
        inventoryEstimateSetting: inventory.enUS.inventoryEstimateSetting,
        // 招标价格验证
        biddingPriceConflict: biddingLocale.enUS.biddingPriceConflict,
        // 招标流程步骤
        biddingSteps: biddingLocale.enUS.biddingSteps,
        // 招标类型管理
        biddingType: biddingLocale.enUS.biddingType,
        // 招标申请
        biddingRequest: biddingLocale.enUS.biddingRequest,
        // 自动服务运行状态查询
        taskStatus: system.enUS.taskStatus,
        // 招标补偿 -- 补偿汇总记录查询
        compensationSummaryList: biddingCompensation.enUS.compensationSummaryList,
        // 招标补偿 -- 药店补偿名单维护
        drugStoreSetting: biddingCompensation.enUS.drugStoreSetting,
        // 招标管理
        certificate: certificate.enUS.certificate,
        // 补偿计算
        compensationCalculation: biddingCompensation.enUS.compensationCalculation,
        // DTP药店基础数据
        drugstore: visit.enUS.drugstore,
        // 巡店计划
        visitPlan: visit.enUS.visitPlan,
        // 巡店结果
        visitResult: visit.zhCN.visitResult,
        // BU与药店基础数据
        drugstoreBUManagement: visit.zhCN.drugstoreBUManagement,
        agreementNotice: agreementNotice.enUS.agreementNotice,
        // 回款商业
        paymentCollection: orderLocale.enUS.paymentCollection,
        // 合作方管理
        partnerManagement: orderLocale.enUS.partnerManagement,
        // 招标月度实际采购价
        biddingMonthRealPrice: biddingLocale.enUS.biddingMonthRealPrice,
        // 日数据预警
        dailySalesflowDefference: salseFlowLocale.enUS.dailySalesflowDefference,
        // DTP数据管理
        dtpDataManagement: salseFlowLocale.enUS.dtpDataManagement,
        // 招标补偿 -- D&W补偿名单维护
        dwCompensationSetting: biddingCompensation.enUS.dwCompensationSetting,
        // 招标补偿 -- D&W补偿系数维护
        dwCompensationCoefficientSetting: biddingCompensation.enUS.dwCompensationCoefficientSetting,
        // 发货模式
        shippingModeManagement: visit.enUS.shippingModeManagement,
        //委托进口折让单价
        commissiondImport: biddingCompensation.enUS.commissiondImport,
        //库存天数维护
        inventoryDaysMaintenance: inventory.enUS.inventoryDaysMaintenance,
        //T1进销存进展
        inventoryOverview: inventory.enUS.inventoryOverview,
        //分货报表
        salesPlanDistributionReport: salesPlanLocale.enUS.salesPlanDistributionReport,
    }
}



// WEBPACK FOOTER //
// ./src/locale/index.js